var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilePdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.741,
    height: 27.725,
    viewBox: "0 0 20.741 27.725",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1072",
    "data-name": "Group 1072",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-file",
    "data-name": "Icon feather-file"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M17.1,3H8.468A2.576,2.576,0,0,0,6,5.673v21.38a2.576,2.576,0,0,0,2.468,2.673H23.273a2.576,2.576,0,0,0,2.468-2.673v-14.7Z",
    transform: "translate(-6 -3)",
    fill: "none",
    stroke: "#e86130",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M19.5,3v9.354h9.354",
    transform: "translate(-9.113 -3)",
    fill: "none",
    stroke: "#e86130",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("text", {
    id: "PDF",
    transform: "translate(3.792 21.071)",
    fill: "#e86130",
    fontSize: 6,
    fontFamily: "Muli-Bold, Muli",
    fontWeight: 700,
    letterSpacing: "0.05em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "PDF")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilePdf);
export default __webpack_public_path__ + "static/media/file-pdf.b4145659bfd2682337174caa07058cbb.svg";
export { ForwardRef as ReactComponent };